<template>
  <el-form :model="formData" :inline="true">
    <el-row>
      <el-col :span="6">
        <el-form-item label="费用提交时间" prop="beginTime">
          <el-date-picker v-if="formData.beginTime" v-model="formData.beginTime" :disabled="true" size="small"></el-date-picker>
          <el-input v-else value="-" disabled size="small"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="协议批次号" prop="protocolId">
          <el-input v-if="formData.batchNo" type="text" v-model="formData.batchNo" :disabled="true" size="small" />
          <el-input v-else type="text" value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="协议编号" prop="protocolId">
          <el-input v-if="formData.protocolId" type="text" v-model="formData.protocolId" :disabled="true" size="small" />
          <el-input v-else type="text" value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="协议状态" prop="protocolNodeName">
          <el-input v-if="formData.protocolNodeName" type="text" v-model="formData.protocolNodeName" :disabled="true" size="small" />
          <el-input v-else type="text" value="-" :disabled="true" size="small" />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/outlay/view/OutlayOtherInfo.vue